<template>
  <div class="portfolio-page">
    <div v-html="data"></div>
  </div>
    
</template>

<script>
  export default {
    props: {
      data: {
        type: String,
      }
    }
  };
</script>

<style lang="scss">
  .portfolio-page {
    iframe {
      height: 100vh !important;
    }
  }
</style>
